// Mi Contador brand mark. Use `variant="full"` where the wordmark should read,
// and `variant="mark"` (character only) when the app title is already present
// next to it.
//
// Sizes are intentionally small — the logo is a decorative brand cue, not a hero.

const LOGO_FULL = "/mi-contador-logo.png";
const LOGO_MARK = "/mi-contador-mark.png";

const SIZES = {
  xs: 20,
  sm: 28,
  md: 36,
  lg: 48,
  xl: 72,
};

export default function Logo({ variant = "full", size = "md", className = "", animate = false, alt = "Mi Contador", testid = "brand-logo" }) {
  const px = SIZES[size] ?? SIZES.md;
  const src = variant === "mark" ? LOGO_MARK : LOGO_FULL;
  // Full logo has 662x254 ratio (≈2.6); mark is roughly square.
  const style = variant === "mark"
    ? { height: px, width: px }
    : { height: px, width: "auto" };
  return (
    <img
      src={src}
      alt={alt}
      className={`brand-logo${animate ? " brand-logo-fade" : ""} ${className}`.trim()}
      style={style}
      data-testid={testid}
      draggable={false}
    />
  );
}
